<ng-container *transloco="let t">
  <app-nav-tabs
    [reduceHorizontalSpacing]="true"
    [isMeasurementTabActive]="isMeasurementTabActive"
    [active]="selectedTabId"
    (onChange)="onChangeTab($event)">
    <app-nav-tab [title]="t('measurements.basic.data')" [itemId]="1">
      <ng-template>
        <app-event-measurements-management-race-list [eventItem]="eventItem" [languages]="languages"
                                                     [raceSettingsList]="settingsList" (onRefreshEventResults)="onRefreshResults()"
                                                     (goToEventManagement)="onGoToEventManagement()"
                                                     (getFileFromServer)="downloadListOfRaces($event)"
        (onSaveOrUpdateRaceStart)="onSaveOrUpdateRaceStart($event)"/>
        <app-event-management-participants-list [languages]="languages" [filter]="filter" [searchForm]="searchForm"
                                                [event]="eventItem" [genders]="genders"
                                                [applicationFormSettingsList]="applicationFromSettingsList"
                                                [raceSettingsList]="settingsList"
                                                [disableRegisterToRace]="disableRegisterToRace"
                                                [competitors]="competitors"
                                                [measurements]="true"
                                                [countries]="countries"
                                                (printStartList)="downloadStartList()"
                                                (refreshCounters)="onRefreshCounters()"
                                                (getFileFromServer)="downloadCompetitorsListForEvent($event.type, $event.filter)"
                                                (chronometarRaceCompetitorStartStop)="onChronometarRaceCompetitorStartStop($event)"/>
      </ng-template>
    </app-nav-tab>
    @if (eventHasNormalRace) {
      <app-nav-tab [title]="t('measurements.measurement.points')" [itemId]="2">
        <ng-template>
          <app-event-measurements-points-laps [eventItem]="eventItem" [waypointsList]="waypointList" [languages]="languages"
                                              [allWaypointList]="allWaypointList" [measurementsPointsView]="true" (refreshCounters)="onRefreshCounters()"
                                              (notifyMeasurementTabActive)="onMeasurementTabActive()"/>
        </ng-template>
      </app-nav-tab>
    }
    @if (eventHasRoundRace) {
      <app-nav-tab [title]="t('measurements.rounds')" [itemId]="3">
        <ng-template>
          <app-event-measurements-points-laps [eventItem]="eventItem" [measurementsPointsView]="false"
                                              [allWaypointList]="allWaypointList" [languages]="languages" (refreshCounters)="onRefreshCounters()"
                                              (notifyMeasurementTabActive)="onMeasurementTabActive()"/>
        </ng-template>
      </app-nav-tab>
    }
    <app-nav-tab [title]="t('race.details.results')" [itemId]="4">
      <ng-template>
        <app-race-results-list-component [race]="eventItem!.racesList![0]" [eventItem]="eventItem"
                                         [genders]="genders" [loadOnInit]="true"
                                         [languages]="languages" />
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>
  <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
